<template>
  <Catalog
    title="Умения исполнителя"
    name-label="Название"
    submit-error="Укажите название."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
import Catalog from "../Catalog.vue";

export default {
  name: "WorkerSkill",
  components: { Catalog },
  mixins: [ catalogs ],
  methods: {
    async fetchData(id) {
      return await this.getWorkerSkillById(id);
    },
    async putData(data) {
      return await this.putWorkerSkill(data);
    },
    async postData(data) {
      return await this.postWorkerSkill(data);
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkerSkills/WorkerSkill.vue